<template>

	<div class="meals-calendar">

		<page-bar />

		<h3 class="page-title" v-translate>Galeria</h3>

		<div class="portlet light ">

			<div class="portlet-title">

				<div class="row">
					<div class="col-md-12">
						<h4 v-translate>Filtrar por:</h4>
					</div>
				</div>

				<div class="row">

					<div class="col-md-4 col-xs-6">
						<label v-translate>Nome do álbum:</label>
						<input type="text" class="form-control" v-model="albumName" placeholder="Nome do álbum">
					</div>

					<!-- <div class="col-md-3">
						<label v-translate>Atribuído para:</label>
						<select class="form-control" name="viewersGallery" v-model="scopeFilter">
							<option></option>
							<option v-for="(value, index) in ENUM.viewersGalleryType" :value="index">{{ value }}</option>
						</select>
					</div> -->

					<div class="col-md-3 col-xs-6">
						<class-list :label="'Turmas:'" :context="'gallery'"/>
					</div>

					<div class="col-md-3 col-xs-6">
						<label v-translate>Alunos:</label>
						<input type="text" class="form-control" v-model="studentName" placeholder="Digite o nome do aluno">
					</div>

					<div class="col-md-2 col-xs-6">
						<button type="button" class="btn btn-block yellow-gold pull-left m-t-24" @click="filter">
							<i aria-hidden="true" class="fa fa-search"></i>
							<span v-translate>Filtrar</span>
						</button>
					</div>
				</div>

			</div>
		</div>

		<div class="portlet light">

			<div class="portlet-body" >
				<div class="row">
					<div class="col-md-12">
						<h4 v-translate>Lista de Álbuns</h4>
					</div>

				</div>

				<div class="row">

					<div class="col-md-2 m-t-10 m-b-15">

						<router-link to="/gallery/album" class="btn red-mint" >
							<i class="fa fa-plus"> </i> <span v-translate>Criar novo álbum</span>
						</router-link>

					</div>
				</div>

				<div class="row">

					<div class="col-md-12">
						<div class="table-responsive">

						<table class="table table-striped table-bordered table-hover">

							<thead class="bg-red-mint bg-font-red-mint">
								<tr>
									<th v-translate>Nome do álbum</th>
									<th v-translate width="250px">Atribuído para</th>
									<th v-translate width="130px">Nro de fotos</th>
									<th v-translate width="200px">Criado por</th>
									<th v-translate width="150px">Data de criação</th>
									<th v-translate width="150px">Ações</th>
								</tr>
							</thead>

							<tbody>

								<tr v-for="(album, index) in list">

									<td class="vertical-align-middle">{{album.title}}</td>
									<td class="vertical-align-middle" v-if="album.scope === 'ALL'"><span v-translate>Para todos os alunos da escola.</span></td>

									<td class="vertical-align-middle" v-if="album.scope === 'SCHOOL_CLASS'">
										<span v-translate>Turmas: </span>
										<span v-for="(klass, index) in album.schoolClasses">
											{{klass.description}}<span v-if="album.students" v-text="album.students.length !== index+1 ? ',' : '.'"></span>
										</span>
									</td>

									<td class="vertical-align-middle" v-if="album.scope === 'STUDENT'">
										<span v-translate>Alunos: </span>
										<span v-for="(student, index) in album.students">
											{{student.name}}<span v-if="album.students.length" v-text="album.students.length !== index+1 ? ',' : '.'"></span>
										</span>
									</td>

									<td class="vertical-align-middle"><i class="fa fa-camera" aria-hidden="true"></i>  {{album.albumSize}} fotos</td>
									<td class="vertical-align-middle" v-if="album.creationUser">{{album.creationUser.name}}</td>
									<td class="vertical-align-middle" v-if="!album.creationUser" v-translate>Não informado</td>
									<td class="vertical-align-middle">{{album.creationDateTime | date("DD/MM/YYYY HH:mm")}}</td>
									<td>
										<router-link tag="a" class="btn btn-block blue m-b-15" :key="album.id" :to="{ path: `/gallery/album/${ album.id }` } ">
											<i class="fa fa-pencil" aria-hidden="true"></i>
											<span v-translate>Editar</span>
										</router-link>

										<button tag="a" v-if="album.status == 'APPROVED'" class="btn btn-block red-mint" @click="unpublish(album.id)">
											<i class="fa fa-times" aria-hidden="true"></i>
											<span v-translate>Despublicar</span>
										</button>

										<button tag="a" v-if="album.status == 'CREATED' || album.status == 'IN_REVISION' " class="btn btn-block green-jungle" @click="publish(album.id)">
											<i class="fa fa-paper-plane-o" aria-hidden="true"></i>
											<span v-translate>Publicar</span>
										</button>
									</td>

								</tr>

							</tbody>
						</table>
						</div>

					</div>

				</div>

				<div class="col-md-12 text-right">

					<pagination v-if="list.length > 0" layout="prev, next" @current-change="handleCurrentChange"></pagination>

				</div>


			</div>
		</div>
	</div>
</div>

</template>

<script>

import Gallery from './';
export default Gallery;

</script>

<style lang="scss" scoped>

html,
body {
	height: 100%;
}

.image {
	width: 100%;
	display: block;
}


.image:hover {
	// -webkit-transform: scale(1.15);
	// -ms-transform: scale(1.15);
	// transform: scale(1.15);
	-webkit-filter: grayscale(90%); /* Safari 6.0 - 9.0 */
	filter: grayscale(90%);
}

h5 {
	font-size: 16px;
}

h4 {
	font-size: 24px;
}

.portlet>.portlet-title {
	border-bottom: 0;
}


</style>



// WEBPACK FOOTER //
// gallery.vue?2b1e687a